import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from '@banyan/modules/admin/services/admin.service';
import {
  ModalComponent
} from '@banyan/modules/standalone/modal/modal.component';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-admin-leave-modal',
  templateUrl: './admin-leave-modal.component.html',
  standalone: true,
  imports: [
    ModalComponent,
    TranslateModule,
    ButtonComponent
  ],
})
export class AdminLeaveModalComponent {
  adminService = inject(AdminService);
  route = inject(ActivatedRoute);
  endUseId: number | null = null;

  constructor(public dialogRef: MatDialogRef<AdminLeaveModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { endUseId: number }
  ) {
    this.endUseId = data.endUseId;
  }

  save() {
    this.adminService.saveRequestProduct(
      this.adminService.request()?.id ?? 0,
      this.endUseId ?? 0,
      this.adminService.request()?.brief.id ?? 0,
      this.adminService.request()?.fragranceProfiles[0].id ?? 0
    );
    this.dialogRef.close('save');
  }

  closeModal(): void {
    this.dialogRef.close('discard');
  }
}
